module.exports = __webpack_public_path__ + "img/achievement_3.751cf2b2.png";